export default __webpack_public_path__ + "components/weather-icon/static/dayrainshowers@3-a93b8809df5b9b68d0605c6ba6fbdebe.png";